<template>
  <div>
    <el-form size="mini" label-width="140px">
      <el-form-item label="生成PDF：">
        <el-button type="primary" @click="exportMultiPagePdf"
          >生成 PDF</el-button
        >
      </el-form-item>
      <el-form-item label="修改图片:">
        <el-upload
          action="#"
          class="avatar-uploader"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="changeImageOneFn"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="宽×高">
        <el-input-number
          v-model="imageUrlW"
          :step="0.1"
          @change="changeImageStyle"
        ></el-input-number>
        <el-input-number
          v-model="imageUrlH"
          :step="0.1"
          @change="changeImageStyle"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="顶部">
        <el-input-number
          v-model="marginTop"
          :step="0.1"
          @change="changeImageStyle"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="左侧">
        <el-input-number
          v-model="marginLeft"
          :step="0.1"
          @change="changeImageStyle"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="行距">
        <el-input-number
          v-model="lineHeight"
          :step="0.1"
          @change="changeLineHeight"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="检测结论行高">
        <el-input-number
          v-model="spacing"
          :step="0.1"
          @change="changeSpacing"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="是否删除">
        <el-checkbox v-model="isShow1" @change="changeImageStyle"></el-checkbox>
        <div>
          <p v-for="(item, idx) in showList" :key="idx">
            已删除：{{ idx + 1 }} <i class="el-icon-delete" @click="deleteFn(item)"></i>
          </p>
        </div>
      </el-form-item>

      <el-form-item label="第一页表格新增">
        <el-select v-model="cols">
          <el-option label="2" :value="2"></el-option>
          <el-option label="4" :value="4"></el-option>
        </el-select>
        <el-button @click="addPageRow" type="primary">新增</el-button>
      </el-form-item>
      <el-form-item label="文字">
        <el-input
          type="textarea"
          v-model="textFiled"
          @input="changeTextFn"
          clearable
          :disabled="textType == '' && textTablePage == 0"
        ></el-input>
      </el-form-item>
      <el-form-item label="表格高">
        <el-input-number
          v-model="tableHeight"
          :step="0.1"
          @change="changeTableHeight"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="添加行">
        <el-button type="primary" @click="addRows">新增</el-button>
      </el-form-item>
      <el-form-item label="页数">
        <el-input-number v-model="pageNumber"></el-input-number>
      </el-form-item>
      <el-form-item label="起始行数（包含）：">
        <el-input-number v-model="rowConut"></el-input-number>
      </el-form-item>
      <el-form-item label="数量">
        <label></label><el-input-number v-model="delToltal"></el-input-number>
        <el-button type="primary" @click="deleteRows">删除</el-button>
        <el-button type="primary" @click="insertRows">插入</el-button>
      </el-form-item>
      <el-form-item label="表格内容">
        <el-input
          v-model="tabelFiled"
          @input="changeTabelFiledFn"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="表格备注">
        <el-input
          v-model="tableRemark"
          @input="changeRemarkFn"
          type="textarea"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="复制新增">
        <el-input v-model="textFileds" type="textarea" clearable></el-input>
        <el-button type="primary" @click="copyTableFn">复制</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageUrl: this.changeImageUrl,
      imageUrlW: 0,
      imageUrlH: 0,
      textFiled: "",
      textFileds: "",
      tabelFiled: "",
      pageNumber: 4,
      rowConut: 0,
      marginTop: 0,
      marginLeft: 0,
      delToltal: 0,
      tableHeight: 18,
      tabelTitle: {
        WeldSeamNumber: "",
        Grade: "",
        DetectionLength: 0,
        WeldingSpecification: "",
        Model: "",
        SerialNumber: "",
        XCoordinate: "",
        YCoordinate: "",
        Depth: "",
        Length: "",
        Amplitude: "",
        Evaluation: "",
      },
      copyTableField: [],
      tableRemark: this.remark,
      lineHeight: 0,
      spacing: 0,
      cols: 2,
      tabelFiledType: undefined,
      isShow1: true,
      showList: [],
    };
  },
  props: [
    "changeImageUrl",
    "urlType",
    "tabelDataObj",
    "textTablePage",
    "textType",
    "changeText",
    "changeTabelFiled",
    "pageObj",
    "remark",
    "selectSpace",
  ],
  watch: {
    changeImageUrl: {
      handler: function (newValue) {
        this.imageUrl = newValue.url;
        this.imageUrlW = newValue.w;
        this.imageUrlH = newValue.h;
        this.marginTop = newValue.top;
        this.marginLeft = newValue.left;
        this.isShow1 = newValue.show
      },
      deep: true,
    },
    changeText: {
      handler: function (newValue) {
        this.textFiled = newValue;
      },
      deep: true,
    },
    pageObj: {
      handler: function (newValue) {
        this.pageNumber = newValue.pageNumber;
        this.rowConut = newValue.rowConut;
        this.delToltal = this.delToltal == 0 ? 1 : this.delToltal;
      },
      deep: true,
    },
    textFileds: {
      handler: function (newValue) {
        this.copyTableField = [];
        console.log(newValue.split("\n"));
        const temp = newValue.split("\n");
        const arr = temp.map((item) => {
          return item.split("\t");
        });
        if (arr[0].length != 0) {
          arr.forEach((item) => {
            const obj = {};
            Object.keys(this.tabelTitle).forEach((title, index) => {
              obj[title] = item[index];
            });
            this.copyTableField.push(obj);
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    getTabelFiled(tabelFiled, type,lineHeight) {
      this.tabelFiledType = type;
      if (type == 1) {
        this.textFiled = tabelFiled;
        this.lineHeight = lineHeight
      } else if (type == 4) {
        this.tabelFiled = tabelFiled;
      }
    },
    getSpacing(newValue) {
      this.spacing = newValue;
    },
    exportMultiPagePdf() {
      this.$emit("exportMultiPagePdf");
    },
    changeImageOneFn(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit(
        "changePhotoFn",
        {
          url: this.imageUrl,
          w: this.imageUrlW,
          h: this.imageUrlH,
          top: this.marginTop,
          left: this.marginLeft,
          show:true,
        },
        this.urlType
      );

      console.log("this.urlType" + this.urlType);
      console.log("item" + this.showList)
    },
    changeImageStyle() {
      console.log("我除法了1")
      this.$emit(
        "changePhotoFn",
        {
          url: this.imageUrl,
          w: this.imageUrlW,
          h: this.imageUrlH,
          top: this.marginTop,
          left: this.marginLeft,
          show: this.isShow1,
        },
        this.urlType
      );
      console.log("this11111" + this.isShow1)
      if (!this.isShow1) {
        const flag = this.showList.some(item=>{
          if(item.imgages.url === this.imageUrl){
            return true
          }
          return false
        })
        if(!flag && this.imageUrl !== ''){
          this.showList.push({
            imgages:{
            url: this.imageUrl,
            w: this.imageUrlW,
            h: this.imageUrlH,
            top: this.marginTop,
            left: this.marginLeft,
            show: true,
          },
          urlType:this.urlType
          });
          this.imageUrl = "";
          this.imageUrlW = "";
          this.imageUrlH = "";
          this.marginTop = "";
          this.marginLeft = "";
        }
      }
    },
    changeTableHeight() {
      this.$emit("changeTableHeightFn", this.tableHeight);
    },
    changeTextFn() {
      if (this.textTablePage === 0) {
        this.$emit("changeTextFn", this.textFiled, this.textType);
      } else if (this.textTablePage === 1) {
        this.$emit("changePageOneTextFn", this.textFiled);
      }
    },
    addPageRow() {
      this.$emit("addPageRow", this.cols);
    },
    copyTableFn() {
      this.$emit("copyRows", this.copyTableField.slice(0, -1));
    },
    changeLineHeight() {
      this.$emit("changeLineHeight", this.lineHeight);
    },
    addRows() {
      this.$emit("addRows");
    },
    deleteFn(item) {
      console.log("dlsjaflksdjl")
      this.$emit("changePhotoFn", item.imgages, item.urlType);
      this.imageUrl = item.imgages.url;
      this.imageUrlW = item.imgages.w;
      this.imageUrlH = item.imgages.h;
      this.marginTop = item.imgages.top;
      this.marginLeft = item.imgages.left;
      this.isShow1 = item.imgages.show
      this.showList = this.showList.filter((list) => {
        if (list.imgages.url != item.imgages.url) {
          return list;
        }
      });
    },
    changeTabelFiledFn() {
      this.$emit("changeTabelFiledFn", this.tabelFiled);
    },
    changeRemarkFn() {
      this.$emit("changeTableRemark", this.tableRemark);
    },
    changeSpacing() {
      this.$emit("changeSpacing", this.spacing);
    },
    // 删除
    deleteRows() {
      if (this.tabelFiledType == 4) {
        let id = 0;
        for (let i = 1; i < this.pageNumber - 3; i++) {
          id += this.tabelDataObj[i].length;
        }
        const delID = id + this.rowConut;
        this.$emit("deleteRows", delID, this.delToltal);
        this.pageNumber = 4;
        this.rowConut = 0;
        this.delToltal = 0;
        this.tabelFiled = "";
      } else {
        this.$emit("deleteRowsPage1", this.delToltal);
        this.pageNumber = 4;
        this.rowConut = 0;
        this.delToltal = 0;
      }
    },
    insertRows() {
      let id = 0;
      if (this.tabelFiledType === 4) {
        for (let i = 1; i < this.pageNumber - 3; i++) {
          id += this.tabelDataObj[i].length;
        }
        const insertID = id + this.rowConut;
        this.$emit("insertRows", 4, this.delToltal, insertID);
      } else {
        this.$emit("insertRows", 1, this.delToltal, this.cols);
      }

    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/report/pdfCtr.vue